import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { AuditSaleRequest } from "../../models/domains/pbm/audit/audit-sale/audit-sale.request";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { AuditSalePageableResultParser } from "../parsers/pbm/audit/audit-sale-pageable-result.parser";
import { AuditSaleDetailsType, AuditSalesType } from "../../models/domains/pbm/audit/audit-sale/audit-sale-details-type.model";

@Injectable()
export class AuditSaleRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory, private auditSalePageableResultParser: AuditSalePageableResultParser) {}

  public async searchAudit(pagingRequest: AuditSaleRequest): Promise<PageableResult> {
    const body = JSON.stringify(pagingRequest);
    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const backendUrl = new BackendUrl("/api/sales-order/audit");
      const payload = await remoteGateway.postWithHeaders(backendUrl, body, headers);
      return this.auditSalePageableResultParser.parse(payload);
    } catch (err) {
      return await Promise.reject(err);
    }
  }

  public async searchAuditDetails(salesOrderKey: string): Promise<AuditSaleDetailsType> {
    const headers = { "Content-Type": "application/json" };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const backendUrl = new BackendUrl("/api/sales-order/audit/" + salesOrderKey);
      const payload: AuditSaleDetailsType = await remoteGateway.getWithHeaders(backendUrl, headers);
      return payload;
    } catch (err) {
      return await Promise.reject(err);
    }
  }
}
